import React, { ReactNode, useEffect, useState } from "react";
import { Alert } from "reactstrap";
import {
  dismissTip,
  ensureUiStateLoaded,
  isTipDismissedLocal,
} from "../../helpers/ui_state_helper";

type Props = {
  /** Chave estável por tela (ex.: blocklist) — sync tenant + localStorage. */
  tipId: string;
  children: ReactNode;
  color?: string;
  className?: string;
};

/**
 * Tip contextual dismissível (X).
 * Por quê: localStorage = instantâneo; ui_state no tenant = mesmo cliente noutro browser (LAC-111).
 */
const DismissiblePageTip = ({
  tipId,
  children,
  color = "info",
  className = "mb-3",
}: Props) => {
  const [visible, setVisible] = useState(() => !isTipDismissedLocal(tipId));

  useEffect(() => {
    let cancelled = false;
    (async () => {
      await ensureUiStateLoaded();
      if (cancelled) {
        return;
      }
      if (isTipDismissedLocal(tipId)) {
        setVisible(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [tipId]);

  if (!visible) {
    return null;
  }

  const dismiss = () => {
    setVisible(false);
    void dismissTip(tipId);
  };

  return (
    <Alert color={color} className={className} toggle={dismiss}>
      {children}
    </Alert>
  );
};

export default DismissiblePageTip;
